<template>
  <div
    :class="{
      'additional-phone': isAdditionalPhone,
    }"
  >
    <m-field-reference-book ref="referencesModal" :field-name="dictionaryFieldName" @updated="updateListVariants" />

    <div class="form-group">
      <c-checkbox v-model="form.custom" type="checkbox" :label="customLabel" />
    </div>
    <div class="form-group">
      <c-checkbox v-model="form.saveCustom" type="checkbox" :label="saveCustomLabel" />
    </div>

    <c-button
      v-if="form.variants.length"
      :responsive="true"
      size="small"
      :icon="{ icon: 'edit' }"
      :label="editDictionaryLabel"
      @click="editReferences"
    />

    <c-button
      v-else
      :responsive="true"
      size="small"
      color="primary"
      :icon="{ icon: 'plus', color: 'white' }"
      label="Создать справочник"
      @click="editReferences"
    />
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CCheckbox from "@/components/controls/switcher";
import MFieldReferenceBook from "../modals/FieldReferenceBook";
import { FIELD_TYPE_ADDITIONAL_PHONE, FIELD_TYPE_RECENT_JOBS } from "@/domains/profile/constants/system-types";

export default {
  components: { CButton, CCheckbox, MFieldReferenceBook },
  props: ["form", "fieldName", "fieldType"],
  computed: {
    isAdditionalPhone() {
      return this.fieldType === FIELD_TYPE_ADDITIONAL_PHONE;
    },
    isRecentJobs() {
      return this.fieldType === FIELD_TYPE_RECENT_JOBS;
    },
    dictionaryFieldName() {
      if (this.isAdditionalPhone) {
        return "Кем приходится";
      }
      if (this.isRecentJobs) {
        return "Должность";
      }
      return this.fieldName;
    },
    customLabel() {
      if (this.isAdditionalPhone) {
        return "Разрешить ввод своих значений в поле «Кем приходится»";
      }
      if (this.isRecentJobs) {
        return "Разрешить ввод своих значений в поле «Должность»";
      }
      return "Разрешить ввод своих значений";
    },
    saveCustomLabel() {
      if (this.isAdditionalPhone) {
        return "Сохранять пользовательские значения в справочник «Кем приходится»";
      }
      if (this.isRecentJobs) {
        return "Сохранять пользовательские значения в справочник «Должность»";
      }
      return "Сохранять в справочник пользовательские значения";
    },
    editDictionaryLabel() {
      if (this.isAdditionalPhone) {
        return "Редактировать справочник «Кем приходится»";
      }
      if (this.isRecentJobs) {
        return "Редактировать справочник «Должность»";
      }
      return "Редактировать справочник";
    },
  },
  created() {
    console.log("form", this.form);
  },
  methods: {
    editReferences() {
      this.$refs.referencesModal.open(this.form.variants);
    },
    updateListVariants(variants) {
      this.form.variants = variants;
      this.$emit("change");
    },
  },
};
</script>
